import React, { useEffect } from "react";

const TujuanProgram: React.FC = () => {
  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-fadeUp");
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
  }, []);

  const tujuan = [
    "Membantu pemerintah menyampaikan informasi kebijakan secara cepat dan akurat.",
    "Meningkatkan literasi publik terhadap isu nasional.",
    "Membangun persepsi positif berbasis data dan kinerja nyata.",
    "Mengurangi dampak hoaks dan framing negatif terhadap kebijakan publik.",
    "Menciptakan kanal komunikasi dua arah antara pemerintah dan masyarakat.",
  ];

  return (
    <section className="relative overflow-hidden bg-white pt-10 pb-24 px-2 md:px-6">
      <div className="max-w-6xl mx-auto relative z-10">
        {/* TITLE */}
        <div className="text-center mb-16 opacity-0 reveal">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900">
            Tujuan <span className="text-[#7a0f1e]">Program</span>
          </h2>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto">Arah strategis dalam membangun komunikasi publik yang efektif, transparan, dan berdampak luas bagi masyarakat.</p>
        </div>

        {/* TIMELINE */}
        <div className="relative">
          {/* LINE */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-[2px] bg-[#7a0f1e]/20"></div>

          <div className="grid md:grid-cols-5 gap-6">
            {tujuan.map((item, index) => (
              <div key={index} className="relative opacity-0 reveal" style={{ transitionDelay: `${index * 120}ms` }}>
                {/* DOT */}
                <div className="hidden md:block absolute -top-6 left-1/2 -translate-x-1/2 w-4 h-4 bg-[#7a0f1e] rounded-full shadow-md"></div>

                {/* CARD */}
                <div className="bg-white border border-gray-200 p-6 rounded-2xl shadow-sm hover:shadow-xl transition duration-300 h-full hover:-translate-y-1">
                  <div className="text-[#7a0f1e] font-bold text-lg mb-2">0{index + 1}</div>

                  <p className="text-gray-700 text-sm leading-relaxed">{item}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TujuanProgram;
